import { L } from '@lib';
import { Divider, Row, Typography } from 'antd';
import React, { memo } from 'react';

const { Text, Title } = Typography;

interface ILubricant {
  name: string;
  quality: string;
  temperature: string;
  viscosity: string;
}

interface IProps {
  lubricant: ILubricant;
}

export const Lubricant: React.FC<IProps> = memo(({ lubricant }) => {
  return (
    <>
      {lubricant && (
        <>
          <Row>
            <Title level={4}>{lubricant.name}</Title>
          </Row>
          {lubricant.quality && (
            <Row>
              <Text>
                {L('Quality')}: {lubricant.quality}
              </Text>
            </Row>
          )}
          {lubricant.temperature && (
            <Row>
              <Text>
                {L('Temperature')}: {lubricant.temperature}
              </Text>
            </Row>
          )}
          {lubricant.viscosity && (
            <Row>
              <Text>
                {L('Viscosity')}: {lubricant.viscosity}
              </Text>
            </Row>
          )}
          <Divider />
        </>
      )}
    </>
  );
});
